import {xCore} from './core';
import { URN as NSURN } from './utils/urn';
import {NSServerCalls} from './utils/servercalls.js';
import {NSDataTypes} from './utils/data_types';
import { NSUserFunctionPermissions } from './user_function_permissions';



export let NSDataModelInfo = {};

NSDataModelInfo.init = function()
{
    NSDataModelInfoPrivate.init();
	
	this.f_load_table = 	    							function () { return NSDataModelInfoPrivate.f_load_table.apply( NSDataModelInfoPrivate, arguments ); };
	this.f_load_table____returning_promise =				function () { return NSDataModelInfoPrivate.f_load_table____returning_promise.apply( NSDataModelInfoPrivate, arguments ); };
	this.f_load_table_list____returning_promise =			function () { return NSDataModelInfoPrivate.f_load_table_list____returning_promise.apply( NSDataModelInfoPrivate, arguments ); };
    this.f_get_table_info =   								function () { return NSDataModelInfoPrivate.f_get_table_info.apply( NSDataModelInfoPrivate, arguments ); };
    this.f_get_table_info_by_table_urn =   					function () { return NSDataModelInfoPrivate.f_get_table_info_by_table_urn.apply( NSDataModelInfoPrivate, arguments ); };
    this.f_get_table_first_geometry_field_info =			function () { return NSDataModelInfoPrivate.f_get_table_first_geometry_field_info.apply( NSDataModelInfoPrivate, arguments ); };
    this.f_get_table_first_geometry_field_info_by_urn =		function () { return NSDataModelInfoPrivate.f_get_table_first_geometry_field_info_by_urn.apply( NSDataModelInfoPrivate, arguments ); };
    this.f_table_has_geometry_by_urn =						function () { return NSDataModelInfoPrivate.f_table_has_geometry_by_urn.apply( NSDataModelInfoPrivate, arguments ); };
	this.f_table_changes_allways_should_clean_tile_cache =	function () { return NSDataModelInfoPrivate.f_table_changes_allways_should_clean_tile_cache.apply( NSDataModelInfoPrivate, arguments ); };
    this.f_field_is_link =      							function () { return NSDataModelInfoPrivate.f_field_is_link.apply( NSDataModelInfoPrivate, arguments ); };
	this.f_field_is_geometry =      						function () { return NSDataModelInfoPrivate.f_field_is_geometry.apply( NSDataModelInfoPrivate, arguments ); };
	this.f_field_geometry_type_is_point =      				function () { return NSDataModelInfoPrivate.f_field_geometry_type_is_point.apply( NSDataModelInfoPrivate, arguments ); };	

    this.f_get_field_info =     									function () { return NSDataModelInfoPrivate.f_get_field_info.apply( NSDataModelInfoPrivate, arguments ); };
    this.f_get_field_info_by_field_internal_name_db =     			function () { return NSDataModelInfoPrivate.f_get_field_info_by_field_internal_name_db.apply( NSDataModelInfoPrivate, arguments ); };


	this.f_get_field_info_by_field_external_name =					function () { return NSDataModelInfoPrivate.f_get_field_info_by_field_external_name.apply( NSDataModelInfoPrivate, arguments ); };
	this.f_get_field_internal_name =     							function () { return NSDataModelInfoPrivate.f_get_field_internal_name.apply( NSDataModelInfoPrivate, arguments ); };
	this.f_field_is_mandatory =     								function () { return NSDataModelInfoPrivate.f_field_is_mandatory.apply( NSDataModelInfoPrivate, arguments ); };
	this.f_get_table_joins_array_of_field_info =					function () { return NSDataModelInfoPrivate.f_get_table_joins_array_of_field_info.apply( NSDataModelInfoPrivate, arguments ); };
	this.f_get_table_fk_joins_array_of_field_info_by_table_urn =	function () { return NSDataModelInfoPrivate.f_get_table_fk_joins_array_of_field_info_by_table_urn.apply( NSDataModelInfoPrivate, arguments ); };
	this.f_get_table_fk_joins_array_of_field_info =					function () { return NSDataModelInfoPrivate.f_get_table_fk_joins_array_of_field_info.apply( NSDataModelInfoPrivate, arguments ); };
	this.f_get_field_joins__array_of_urn =							function () { return NSDataModelInfoPrivate.f_get_field_joins__array_of_urn.apply( NSDataModelInfoPrivate, arguments ); };
	this.f_get_table_child_joins_array_of_field_info_by_table_urn =	function () { return NSDataModelInfoPrivate.f_get_table_child_joins_array_of_field_info_by_table_urn.apply( NSDataModelInfoPrivate, arguments ); };
	

	
	window.NSDataModelInfo_ = NSDataModelInfo;
	window.NSDataModelInfoPrivate_ = NSDataModelInfoPrivate;
	
}


let NSDataModelInfoPrivate = 
{
	private_objs:
	{
		settings: null, //config settings
		
		o_dmi: null
	},
	
	o_dmi: null,
	
	init: function()
	{
		var private_objs = this.private_objs;
		
		private_objs.o_dmi = {};
		
		var moduleName = "NSSchemaInfo";
		//private_objs.settings = xCore.loader.modules[moduleName].settings; AQUIIIIII TODO TO DO
		
		this.o_dmi = this.private_objs.o_dmi;
		
		//NSExternalSchemas.load(); AQUIIIIIIIIIIII TODO TO DO
		
	},
	


	/**
	 * @typedef {Object} ObjIn_load_table_list____returning_promise
	 * @property {string[]} a_s_table_urn 
	 * @property {boolean} b_full_info 
	 */

	/**
	 * @param {ObjIn_load_table_list____returning_promise} o_in 
	 * @summary o_in: {a_s_table_urn, b_full_info, b_dont_force_sucess_to_all_calls}
	 * @returns {Promise}
	 */
	f_load_table_list____returning_promise: function(o_in)
	{
		let a_s_table_urn = o_in.a_s_table_urn;
		let b_full_info = o_in.b_full_info;
		let b_dont_force_sucess_to_all_calls = o_in.b_dont_force_sucess_to_all_calls;

		let a_promise = [];

		a_s_table_urn.forEach( (s_table_urn_i) => {

			let o_promise_i = this.f_load_table____returning_promise({			
				b_full_info: b_full_info,
				s_table_urn: s_table_urn_i
			});
			a_promise.push(o_promise_i);
		} );

		if(b_dont_force_sucess_to_all_calls)
		{
			let o_promise_all = Promise.allSettled(a_promise);
			return o_promise_all;
		}
		else
		{
			let o_promise_all = Promise.all(a_promise);
			return o_promise_all;
		}
		
	},

	/*
        o_in:
        {
            b_full_info,

            s_table_urn
            ||
            schema_name,
            table_name,
        }
		promise.then(function(b_error, s_message),...)
    */
	f_load_table____returning_promise: function(o_in)
	{

		return new Promise ( (resolve, reject) => 
			{
				//setTimeout(resolve, ms)


				let f_cb = function (b_error, s_message)
				{
					if(!b_error)
					{
						resolve(b_error, s_message);
					}
					else
					{
						
						console.error("rejecting. o_in:");
						console.log(o_in);
						reject( { message: s_message } );
					}
				}

				this.f_load_table(o_in, f_cb);
			
			}
		);


	},
	/*
        o_in:
        {
            b_full_info,

            s_table_urn
            ||
            schema_name,
            table_name,
        }
		f_callback	->function (b_error, s_message)
    */
	f_load_table: function(o_in, f_callback)
	{
		var this_ = this;
		
        let s_schema = o_in.schema_name;
		let s_table_internal_name = o_in.table_name;

        if(o_in.s_table_urn != null)
        {
            let a_table_urn_info = NSURN.f_get_urn_info(o_in.s_table_urn);
            s_schema = a_table_urn_info[1];
            s_table_internal_name = a_table_urn_info[2];
        }
        else
        {
            s_schema = o_in.schema_name;
            s_table_internal_name = o_in.table_name;
        }
		
		
		var b_table_is_loaded = this.f_table_is_loaded(s_schema, s_table_internal_name, o_in.b_full_info);
		
		if(b_table_is_loaded)
		{
			var b_error = false;
			var s_message = "";
			f_callback(b_error, s_message);
			return;
		}
		else
		{
			var s_table_urn = NSURN.f_create_table_urn(s_schema, s_table_internal_name);
			//var b_has_permissions = true; // NSUserFunctionPermissions.f_has_permission_for_function_type_GSS_EXTENDED_APPLICATION_SCHEMA_LOCAL_and_table_urn(s_table_urn); AQUIIIIIIIIII TODO TO DO
			let b_has_permissions = NSUserFunctionPermissions.f_has_permission_for_function_type_READ_and_collection_urn(s_table_urn);
			if(!b_has_permissions)
			{
				var b_error = true;
				var s_message = "O utilizador não possui permissão para efectuar esta operação.";
				f_callback(b_error, s_message);
				return;
			}
			
			
			var f_cb = function(o_resp)
			{
				this_.f_load_table_process_response_(o_resp, s_table_urn, f_callback );			
			};
			

            NSServerCalls.f_data_model_info_get_table(
                {
                    "table_urn": s_table_urn,
                    //"language",     				//optional default: "pt", 
                    "full_info": o_in.b_full_info	//optional default: "false", 
                },
                f_cb        
            );

		}
		
		
	},
	
	f_table_is_loaded: function(s_schema, s_table_internal_name, b_full_info)
	{
		var o_schema_info = this.f_get_table_info(s_schema, s_table_internal_name);
		//var b_table_is_loaded = (o_schema_info!=null)? true : false;

		var b_table_is_loaded = ( o_schema_info !=null
								
									&& ( !b_full_info || ( b_full_info && o_schema_info.b_full_info ) )
								
								)? true : false;

		
		
		return b_table_is_loaded;
		
	},
	f_get_table_info: function(s_schema, s_table_internal_name)
	{
		var private_objs = this.private_objs;

		if(private_objs.o_dmi == null || Object.keys(private_objs.o_dmi).length === 0 )
		{
			return null;
		}
        
		var o_schema_info = private_objs.o_dmi[s_schema];
        
		
		if(o_schema_info == null)
		{
			return null;
		}		
        
		var o_table_info = o_schema_info.tables[s_table_internal_name];
        
		
		return o_table_info;
	},
	f_get_table_info_by_table_urn: function(s_table_urn)
	{
		let a_urn_info = NSURN.f_get_urn_info(s_table_urn);
		let s_schema = a_urn_info[1];
		let s_table_internal_name = a_urn_info[2];

		let o_table_info = this.f_get_table_info(s_schema, s_table_internal_name)


		return o_table_info;
	},
	f_get_field_info_by_field_external_name: function(s_schema, s_table_internal_name, s_field_external_name)
	{
		
		var o_table_info = this.f_get_table_info(s_schema, s_table_internal_name);
		
		var a_column_info = o_table_info.a_column_info;

		for(var i=0; i< a_column_info.length; i++)
		{
			var o_field_info_i = a_column_info[i];
			if( s_field_external_name == o_field_info_i.external_name )
			{
				return o_field_info_i;
			}
		}
		
		return null;
	},
	f_get_field_internal_name: function(s_schema, s_table_internal_name, s_field_external_name)
	{
		
		var o_field_info_i = this.f_get_field_info_by_field_external_name(s_schema, s_table_internal_name, s_field_external_name);
		if(o_field_info_i != null)
		{
			return o_field_info_i.internal_name;
		}
		else
		{
			return null;
		}
	},
	f_get_field_info: function(s_schema, s_table_internal_name, s_field_internal_name)
	{
		
		var o_table_info = this.f_get_table_info(s_schema, s_table_internal_name);

		/*
		
		var a_column_info = o_table_info.a_column_info;

		for(var i=0; i< a_column_info.length; i++)
		{
			var o_field_info_i = a_column_info[i];
			if( s_field_internal_name == o_field_info_i.internal_name )
			{
				return o_field_info_i;
			}
		}

		return o_field_info;
		*/

		return o_table_info.extra.a_column_info_ref_by_internal_name[s_field_internal_name];
	},
	f_get_field_info_by_field_internal_name_db: function(s_schema, s_table_internal_name, s_field_internal_name_db)
	{
		
		var o_table_info = this.f_get_table_info(s_schema, s_table_internal_name);

		
		
		var a_column_info = o_table_info.a_column_info;

		for(var i=0; i< a_column_info.length; i++)
		{
			var o_field_info_i = a_column_info[i];
			if( ( o_field_info_i.internal_name_db != null && s_field_internal_name_db == o_field_info_i.internal_name_db )
				|| ( o_field_info_i.internal_name_db == null && s_field_internal_name_db == o_field_info_i.internal_name ) )
			{
				return o_field_info_i;
			}
		}

		return null;

	},
	f_get_table_first_geometry_field_info: function(s_schema, s_table_internal_name)
	{

		let s_table_urn = NSURN.f_create_table_urn(s_schema, s_table_internal_name);
		return this.f_get_table_first_geometry_field_info_by_urn(s_table_urn);

	},

	f_get_table_first_geometry_field_info_by_urn: function(s_table_urn)
	{
		let o_table_info = NSDataModelInfo.f_get_table_info_by_table_urn(s_table_urn);

		let a_table_urn_info = NSURN.f_get_urn_info(s_table_urn);
		let s_schema = a_table_urn_info[1];
		let s_table_internal_name = a_table_urn_info[2];

		let a_column_info = o_table_info.a_column_info;

		for(let i=0; i< a_column_info.length; i++)
		{
			let o_field_info_i = a_column_info[i];

			let b_field_is_geometry =this.f_field_is_geometry(s_schema, s_table_internal_name, o_field_info_i.internal_name)
			if( b_field_is_geometry )
			{
				return o_field_info_i;
			}
		}

		return null;

	},

	f_table_has_geometry_by_urn: function(s_table_urn)
	{
		let o_geometry_field_info = this.f_get_table_first_geometry_field_info_by_urn(s_table_urn);

		let b_table_has_geometry = (o_geometry_field_info != null) ? true : false;

		return b_table_has_geometry;

	},

	f_table_changes_allways_should_clean_tile_cache: function(s_table_urn)
	{
		let o_table_info = NSDataModelInfo.f_get_table_info_by_table_urn(s_table_urn);

		let a_table_urn_info = NSURN.f_get_urn_info(s_table_urn);
		let s_schema = a_table_urn_info[1];
		let s_table_internal_name = a_table_urn_info[2];

		let list_of_tables_with_dependent_geoserver_tile_layer = o_table_info.list_of_tables_with_dependent_geoserver_tile_layer;

		let b_on_change_allways_clean_tile_cache = (list_of_tables_with_dependent_geoserver_tile_layer != null 
													&& list_of_tables_with_dependent_geoserver_tile_layer.length >0)? true : false;

		return b_on_change_allways_clean_tile_cache;

	},
	
	f_load_table_process_response_: function(o_resp, s_table_urn, f_callback)
	{
		var this_ = this;
		var private_objs = this.private_objs;
		var o_dmi = private_objs.o_dmi;

        let a_table_urn_info =  NSURN.f_get_urn_info(s_table_urn);
        let s_schema = a_table_urn_info[1];
        let s_table_internal_name = a_table_urn_info[2];

		
		//load received info
		if(o_dmi[s_schema] == null)
		{
			/*
				schema_info:
				{
					internal_name,
					external_name,
					tables: {}
				}
				
			*/
            let o_schema_info = {
                internal_name: s_schema,
                tables: {}
            };
			o_dmi[s_schema] = o_schema_info;
		}

        let b_full_info = (o_resp.table_info_full != null)? true : false;
        let o_table_info_new = ( b_full_info )? o_resp.table_info_full : o_resp.table_info_basic;
        o_table_info_new.b_full_info = b_full_info;

        o_table_info_new.extra = {};
        o_table_info_new.extra.a_unordered_columns____ = [];
        o_table_info_new.extra.a_ordered_columns = [];
        o_table_info_new.extra.a_ordered_visible_columns = [];
        o_table_info_new.extra.a_column_info_ref_by_internal_name = [];
		o_table_info_new.extra.a_column_info_original = o_table_info_new.a_column_info;
        o_table_info_new.extra.a_list_of_tables_with_dependent_geoserver_tile_layer = null;
		
		/*
        o_table_info_new.a_column_info.forEach((o_col_info) => { 
            o_table_info_new.extra.a_unordered_columns____.push(o_col_info.internal_name);  
            o_table_info_new.extra.a_column_info_ref_by_internal_name[o_col_info.internal_name] = o_col_info;
        } );
		*/
		
		/*
		edit and prepare table columns
			->joins(is_fk and is_target) will receive as names the join table name
				->but the DB column original names will be stored in "internal_name_db" and "external_name_db"
			->to every join external_col_urn property will be added
			->for each external join create a new column_info entry

			new properties:
				internal_name_db,	// column internal name in db wich is "is_fk" or "is_target"
				external_name_db,	// column external name in db wich is "is_fk" or "is_target"
				external_col_urn	
		*/
		o_table_info_new.a_column_info = [];
		o_table_info_new.extra.a_column_info_original.forEach((o_col_info_i) => {
			
			//adding enumerator_values as an array for convenience
			if(o_col_info_i.is_enum)
			{

				if(o_col_info_i.enumerator_values != null 			// normal enums
					&& !o_col_info_i.is_enum_multi_cols_master 
					&& !o_col_info_i.is_enum_multi_cols_passive )
				{
					o_col_info_i.a_enumerator_values = o_col_info_i.enumerator_values.split(";");
				}
				else if (o_col_info_i.is_enum_multi_cols_master)	// enums_multi_cols
				{
					let o_enumerator_multi_cols_values = o_col_info_i.enumerator_multi_cols_values;
					
					o_col_info_i.a_enumerator_values = o_col_info_i.enumerator_multi_cols_values[o_col_info_i.target_enum_master_col_name]; // values of enum master

					/*let a_keys = Object.keys(o_enumerator_multi_cols_values);
					a_keys.forEach( (s_key_i) =>
					{
						if( s_key_i != "id" && s_key_i != o_col_info_i.target_enum_master_col_name)
						{
							// s_key_i is the internal_name of a passive col for the enum_multi
							//getting enum passive col info
							let o_col_info_of_enum_passive_col = o_table_info_new.extra.a_column_info_original.find( (o_col_info_j) =>
							{
								return o_col_info_j.internal_name == s_key_i;
							});
							
							if( o_col_info_of_enum_passive_col != null)
							{
								o_col_info_of_enum_passive_col.a_enumerator_values = o_col_info_i.enumerator_multi_cols_values[s_key_i]; // values of enum passive/slave col
							}
						}
					});*/
					
				}
				else if (o_col_info_i.is_enum_multi_cols_passive)
				{
					// do nothing, theyre content is processed by enum master (previous "if")
					let o_col_info_of_enum_master_col = o_table_info_new.extra.a_column_info_original.find( (o_col_info_j) =>
					{
						return o_col_info_j.internal_name == o_col_info_i.enum_multi_cols_master_col_internal_name;
					});
					o_col_info_i.a_enumerator_values = o_col_info_of_enum_master_col.enumerator_multi_cols_values[o_col_info_i.internal_name];
				}

			}

			if(o_col_info_i.is_fk || o_col_info_i.is_target)
			{
				if( o_col_info_i.is_fk )
				{
					//shallow copy
					let o_col_info_i_new = Object.assign({}, o_col_info_i);
					o_col_info_i_new.internal_name_db = o_col_info_i_new.internal_name;
					o_col_info_i_new.external_name_db = o_col_info_i_new.external_name;

					o_col_info_i_new.internal_name = o_col_info_i.target_table_internal_name;
					o_col_info_i_new.external_name = o_col_info_i.target_table_external_name;

					let s_external_col_urn = NSURN.f_create_field_urn(	o_col_info_i.target_schema_internal_name, 
						o_col_info_i.target_table_internal_name, 
						o_col_info_i.target_column_internal_name);
					
					o_col_info_i_new.external_col_urn = s_external_col_urn;

					o_col_info_i_new.is_join = true;


					o_table_info_new.a_column_info.push(o_col_info_i_new);
				

				}
				if( o_col_info_i.is_target )
				{
					
					o_col_info_i.a_column_joins_as_target.forEach(( o_column_join_as_target_i) => { 
						
						//shallow copy
						let o_col_info_i_new = Object.assign({}, o_col_info_i);
						o_col_info_i_new.internal_name_db = o_col_info_i_new.internal_name;
						o_col_info_i_new.external_name_db = o_col_info_i_new.external_name;

						o_col_info_i_new.internal_name = o_column_join_as_target_i.table_internal_name;
						o_col_info_i_new.external_name = o_column_join_as_target_i.table_external_name;

						let s_urn_i = NSURN.f_create_field_urn(o_column_join_as_target_i.schema_internal_name, o_column_join_as_target_i.table_internal_name, o_column_join_as_target_i.column_internal_name);
		
						o_col_info_i_new.external_col_urn = s_urn_i;

						o_col_info_i_new.is_join = true;


						o_table_info_new.a_column_info.push(o_col_info_i_new);
		
					} );
				}

			}
			else
			{
				//shallow copy
				let o_col_info_i_new = Object.assign({}, o_col_info_i);
				o_col_info_i_new.is_join = false;

				o_table_info_new.a_column_info.push(o_col_info_i_new);
			}
		});
		

		let a_column_info_to_be_ordered = []
		o_table_info_new.a_column_info.forEach((o_col_info) => { 
            o_table_info_new.extra.a_unordered_columns____.push(o_col_info.internal_name);  
            o_table_info_new.extra.a_column_info_ref_by_internal_name[o_col_info.internal_name] = o_col_info;

			a_column_info_to_be_ordered.push(o_col_info);
        } );
		a_column_info_to_be_ordered.sort((a,b) => {
			/*
				> 0	sort b before a
				< 0	sort a before b
				=== 0	keep original order of a and b
			*/
			let b_res; //
			if( (a.order == null && b.order == null) || (a.order == b.order) )
			{
				b_res = 0;
			}
			else if (a.order == null ) 
			{
				b_res = 1;
			}
			else if (b.order == null ) 
			{
				b_res = -1;
			}
			else
			{
				b_res = (a.order > b.order) ? 1 : -1;
			}

			//special cases:
			if(b_res==0) //tie
			{
				/*
				if(a.is_join && !b.is_join) { b_res = 1; }
				if(!a.is_join && b.is_join) { b_res = -1; }
				*/

				let f_get_local_order_score = function (o_col_info)
				{
					let i_local_order = 1;
					
					if(o_col_info.is_link)
					{
						i_local_order = 10;
					}
					else if(o_col_info.is_join)
					{
						i_local_order = 50;
					}
					else if(NSDataTypes.f_type_is_geometry(o_col_info.data_type))
					{
						i_local_order = 100;
					}
					return i_local_order;
				}
				
				let i_a_local_order = f_get_local_order_score(a);
				let i_b_local_order = f_get_local_order_score(b);
				b_res = (i_a_local_order > i_b_local_order) ? 1 : -1;

				
			}

			return b_res;

		});

		//storing ordered column names
		let b_page_in_ext_context = xCore.application.b_page_in_ext_context;
		a_column_info_to_be_ordered.forEach((o_col_info) => { 
            o_table_info_new.extra.a_ordered_columns.push(o_col_info.internal_name);  


			let b_column_is_visible = (
				( !b_page_in_ext_context && !o_col_info.is_hidden )
				|| ( b_page_in_ext_context && !o_col_info.is_hidden_in_external_client )
			)? true : false; 
			
			if(b_column_is_visible)
			{
				o_table_info_new.extra.a_ordered_visible_columns.push(o_col_info.internal_name);  
			}
			
        } );

		//list_of_tables_with_dependent_geoserver_tile_layer -> storing it in array format
		if(o_table_info_new.list_of_tables_with_dependent_geoserver_tile_layer != null && o_table_info_new.list_of_tables_with_dependent_geoserver_tile_layer.length > 0)
		{
			o_table_info_new.extra.a_list_of_tables_with_dependent_geoserver_tile_layer = o_table_info_new.list_of_tables_with_dependent_geoserver_tile_layer.split(";");
		}
		




        //store
        o_dmi[s_schema].tables[s_table_internal_name]  = o_table_info_new;


		//add join column info to table (o_table_info_new.extra.a_join_column_info):
		this.f_generate_table_a_join_column_info(s_schema, s_table_internal_name);
 
		
		
		
		
		
		//load enumerators
		
		var f_cb_on_complete = function()
		{
			//console.log('table schema info and its enmerators loading complete!');
			//f_callback(false, "load completed");
			f_callback();
		}
		
        f_cb_on_complete(); // AQUIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIII TODO TO DO
        return; // AQUIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIII TODO TO DO

		if(o_table_info.enumerators !=  null && o_table_info.enumerators.length>0)
		{
			var o_ajax_sync = new NSAJAXSync.objs.Sync(f_cb_on_complete);
			/*
			o_ajax_sync.f_add_new_call();
			o_ajax_sync.f_set_state_all_calls_are_started();
			o_ajax_sync.f_finish_call();
			*/
			
			
			var f_get_f_cb = function (o_field_enumerator_i)
			{
				return function (o_resp)
				{
					this_.f_getCatalogueEntries_process_response_(o_resp, o_field_enumerator_i);
					o_ajax_sync.f_finish_call();
				}
			}
			
			var a_enumerators = o_table_info.enumerators;
			for( var i=0; i<a_enumerators.length; i++)
			{
				var s_field_enumerator_key_i = a_enumerators[i];
				var o_field_enumerator_i = o_table_info.fields[s_field_enumerator_key_i];
				var s_field_internal_name = o_field_enumerator_i.internal_name; // same has s_field_enumerator_key_i
			
			
				var f_cb = f_get_f_cb(o_field_enumerator_i);
			
				/*
				o_in -> 
				{
					schema_name -> ex:"municipio" 
					table_name -> ex:"mn_loteamento" 
					field_name -> ex:"arranjos_exteriores" 
					//ace_name -> ex:"internet1" 

				},
				f_callback -> function(o_resp)
				*/
				var o_in = 
				{
					schema_name: s_schema,
					table_name: s_table_internal_name,
					field_name: s_field_internal_name,
					//ace_name: NSAce.f_get_ace_name()
				}
				o_ajax_sync.f_add_new_call();
				comms.getCatalogueEntries(o_in, f_cb);
				
			}
			o_ajax_sync.f_set_state_all_calls_are_started();
		}
		else
		{
			f_cb_on_complete();
		}
		
	  
		
		
		
	},
	
	f_getCatalogueEntries_process_response_: function(o_resp, o_field_enumerator_i)
	{
		
		var a_catalogue_entries = o_resp.catalogueEntries;
		o_field_enumerator_i.a_catalogue_entries = a_catalogue_entries;
		
	},
	
	f_field_is_link: function(s_schema, s_table_internal_name, s_field_internal_name)
	{
		var o_table_info = this.f_get_table_info(s_schema, s_table_internal_name);
        
        /*
		var a_links = o_table_info.links;
		if(a_links != null)
		{
			for(var i=0; i<a_links.length; i++)
			{
				if(s_field_internal_name == a_links[i])
				{
					return true;
				}
			}				
		}
		
		return false;
        */
        return o_table_info.extra.a_column_info_ref_by_internal_name[s_field_internal_name].is_link;
		
	},

	f_field_is_geometry: function(s_schema, s_table_internal_name, s_field_internal_name)
	{
		let o_table_info = this.f_get_table_info(s_schema, s_table_internal_name);

        return NSDataTypes.f_type_is_geometry(o_table_info.extra.a_column_info_ref_by_internal_name[s_field_internal_name].data_type);
		
	},

	f_field_geometry_type_is_point: function(s_schema, s_table_internal_name, s_field_internal_name)
	{
		var o_table_info = this.f_get_table_info(s_schema, s_table_internal_name);

        return NSDataTypes.f_geometry_type_is_point(o_table_info.extra.a_column_info_ref_by_internal_name[s_field_internal_name].data_type);
		
	},
	
	// Atention this method should only be called if full table info is loaded!!!!!!!!!!!!!!!!!!!!!
	f_field_is_mandatory: function(o_field_info)
	{
		var b_ = (o_field_info.mandatory != null && o_field_info.mandatory == true)? true :  false;
		
		return b_;
		
	},
	
	

	//new methods:
	f_get_table_joins_array_of_field_info: function(s_schema, s_table_internal_name)
	{
		let a_field_info = [];
		var o_table_info = this.f_get_table_info(s_schema, s_table_internal_name);
		
		var a_column_info = o_table_info.a_column_info;

		for(var i=0; i< a_column_info.length; i++)
		{
			var o_field_info_i = a_column_info[i];
			if( o_field_info_i.is_fk ||  o_field_info_i.is_target)
			{
				a_field_info.push(o_field_info_i);
			}
		}

		return a_field_info;
	},

	//only fk join fields will be returned
	f_get_table_fk_joins_array_of_field_info_by_table_urn: function(s_table_urn)
	{
		let a_urn_info = NSURN.f_get_urn_info(s_table_urn);
		return this.f_get_table_fk_joins_array_of_field_info(a_urn_info[1], a_urn_info[2]);
	},

	//only fk join fields will be returned
	f_get_table_fk_joins_array_of_field_info: function(s_schema, s_table_internal_name)
	{
		let a_field_info = [];
		var o_table_info = this.f_get_table_info(s_schema, s_table_internal_name);
		
		var a_column_info = o_table_info.a_column_info;

		for(var i=0; i< a_column_info.length; i++)
		{
			var o_field_info_i = a_column_info[i];
			if( o_field_info_i.is_fk)
			{
				a_field_info.push(o_field_info_i);
			}
		}

		return a_field_info;
	},

	//only target/child join fields will be returned
	f_get_table_child_joins_array_of_field_info_by_table_urn: function(s_table_urn)
	{
		let a_urn_info = NSURN.f_get_urn_info(s_table_urn);
		return this.f_get_table_child_joins_array_of_field_info(a_urn_info[1], a_urn_info[2]);
	},

	//only target/child join fields will be returned
	f_get_table_child_joins_array_of_field_info: function(s_schema, s_table_internal_name)
	{
		let a_field_info = [];
		var o_table_info = this.f_get_table_info(s_schema, s_table_internal_name);
		
		var a_column_info = o_table_info.a_column_info;

		for(var i=0; i< a_column_info.length; i++)
		{
			var o_field_info_i = a_column_info[i];
			if( o_field_info_i.is_target)
			{
				a_field_info.push(o_field_info_i);
			}
		}

		return a_field_info;
	},

	f_get_field_joins__array_of_urn: function(s_schema, s_table_internal_name, s_field_internal_name)
	{
		let a_joins_urns = [];

		var o_field_info_i = this.f_get_field_info(s_schema, s_table_internal_name, s_field_internal_name);

		if( o_field_info_i.is_fk || o_field_info_i.is_target)
		{
			let s_urn = o_field_info_i.external_col_urn;
			a_joins_urns.push(s_urn);			
		}

		return a_joins_urns;
	},

	//only fk join fields will be returned
	f_get_table_fk_join_to_spatial_context_provider_by_table_urn: function(s_table_urn)
	{

		let o_col_info_of_first_geom = NSDataModelInfoPrivate_.f_get_table_first_geometry_field_info_by_urn(s_table_urn);
		if(o_col_info_of_first_geom != null)
		{
			//console.log("Table already has a geometry, makes no sense to search an inherited geometry");
			return null; // table already has a geometry, makes no sense to search an inherited geometry
		}

		let o_table_info = this.f_get_table_info_by_table_urn(s_table_urn);
		let a_fk_column_info = this.f_get_table_fk_joins_array_of_field_info_by_table_urn(s_table_urn);

		let s_linked_sc_provider_table_urn = o_table_info.linked_spatial_context_provider_table_urn;
		let b_linked_sc_provider_is_defined = (s_linked_sc_provider_table_urn != null && s_linked_sc_provider_table_urn != "")? true: false;

		// if b_linked_sc_provider_is_defined is undefined, function assumes that table has just on FK and returns first.
		for(let i=0; i<a_fk_column_info.length; i++)
		{
			let o_fk_column_info_i = a_fk_column_info[i];
			if(b_linked_sc_provider_is_defined)
			{
				let s_target_col_urn = o_fk_column_info_i.external_col_urn;
				let s_target_table_urn = NSURN.f_create_table_urn_from_column_urn(s_target_col_urn);
				if(s_target_table_urn == s_linked_sc_provider_table_urn)
				{
					//console.log("FOUND CONFIGURED FK LINK TO SPATIAL CONTEXT PROVIDER");
					return o_fk_column_info_i;
				}

			}
			else // if b_linked_sc_provider_is_defined is undefined, function assumes that table has just on FK and returns first.
			{
				//console.log("NO CONFIGURED FK LINK TO SPATIAL CONTEXT PROVIDER -> assuming only one FK and returning it");
				return o_fk_column_info_i;
			}
		}

		return null;

	},
	
	f_generate_table_a_join_column_info_from_original_data: function(s_schema, s_table_internal_name)
	{
		let a_join_column_info = [];

		var o_table_info = this.f_get_table_info(s_schema, s_table_internal_name);

		//let a_column_info = this.f_get_table_joins_array_of_field_info(s_schema, s_table_internal_name);
		let a_column_info = o_table_info_new.extra.a_column_info_original;

		a_column_info.forEach((o_col_info_i) => {

			if(o_col_info_i.is_fk)
			{
				let s_external_col_urn = NSURN.f_create_field_urn(	o_col_info_i.target_schema_internal_name, 
					o_col_info_i.target_table_internal_name, 
					o_col_info_i.target_column_internal_name);

				//create and add new element
				let o_join_col_info = 
				{
					is_fk: true,
					is_target: false,
					internal_name: o_col_info_i.internal_name,
					external_name: o_col_info_i.external_name,
					data_type: o_col_info_i.data_type,
					
					external_col_urn: s_external_col_urn
				};
				a_join_column_info.push(o_join_col_info);
			}
			if(o_col_info_i.is_target)
			{
				let a_column_joins_as_target = o_col_info_i.a_column_joins_as_target;
			
				a_column_joins_as_target.forEach(( o_column_join_as_target_i) => { 
						
					let s_urn_i = NSURN.f_create_field_urn(o_column_join_as_target_i.schema_internal_name, o_column_join_as_target_i.table_internal_name, o_column_join_as_target_i.column_internal_name);
	
					//create and add new element
					let o_join_col_info = 
					{
						is_fk: false,
						is_target: true,
						internal_name: o_col_info_i.internal_name,
						external_name: o_col_info_i.external_name,
						data_type: o_col_info_i.data_type,
						
						external_col_urn: s_urn_i,
						external_col_external_name: o_column_join_as_target_i.table_external_name
					};
					a_join_column_info.push(o_join_col_info);
	
				} );
			}
			
		})

		o_table_info.extra.a_join_column_info = a_join_column_info;

	},
	
	f_generate_table_a_join_column_info: function(s_schema, s_table_internal_name)
	{
		let a_join_column_info = [];

		var o_table_info = this.f_get_table_info(s_schema, s_table_internal_name);

		let a_column_info = this.f_get_table_joins_array_of_field_info(s_schema, s_table_internal_name);

		a_column_info.forEach((o_col_info_i) => {

			if(o_col_info_i.is_fk || o_col_info_i.is_target)
			{
				let s_external_col_urn = o_col_info_i.external_col_urn;

				//create and add new element
				let o_join_col_info = 
				{
					is_fk: o_col_info_i.is_fk,
					is_target: o_col_info_i.is_target,
					internal_name: o_col_info_i.internal_name,
					external_name: o_col_info_i.external_name,

					internal_name_db: o_col_info_i.internal_name_db,
					external_name_db: o_col_info_i.external_name_db,

					data_type: o_col_info_i.data_type,
					
					external_col_urn: s_external_col_urn
				};
				a_join_column_info.push(o_join_col_info);
			}
			
		})

		o_table_info.extra.a_join_column_info = a_join_column_info;

	}


	
	

	
}

